function clsx() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return [].concat(classes).filter(Boolean).join(" ");
}

function cssClass(suffix) {
  return ["react-photo-album", suffix].filter(Boolean).join("--");
}

function cssVar(suffix) {
  return "--".concat(cssClass(suffix));
}

function ratio(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return width / height;
}

var breakpoints = Object.freeze([1200, 600, 300, 0]);

function unwrap(value, arg) {
  return typeof value === "function" ? value(arg) : value;
}

function unwrapParameter(value, containerWidth) {
  return containerWidth !== void 0 ? unwrap(value, containerWidth) : void 0;
}

function selectResponsiveValue(values, containerWidth) {
  var index = breakpoints.findIndex(function (breakpoint) {
    return breakpoint <= containerWidth;
  });
  return unwrap(values[Math.max(index, 0)], containerWidth);
}

function resolveResponsiveParameter(parameter, containerWidth, values) {
  var minValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (containerWidth === void 0) return void 0;
  var value = unwrapParameter(parameter, containerWidth);
  return Math.round(Math.max(value === void 0 ? selectResponsiveValue(values, containerWidth) : value, minValue));
}

function resolveCommonProps(containerWidth, _ref2) {
  var spacing = _ref2.spacing,
      padding = _ref2.padding,
      componentsProps = _ref2.componentsProps,
      render = _ref2.render;
  return {
    spacing: resolveResponsiveParameter(spacing, containerWidth, [20, 15, 10, 5]),
    padding: resolveResponsiveParameter(padding, containerWidth, [0, 0, 0, 0]),
    componentsProps: unwrap(componentsProps, containerWidth) || {},
    render: unwrap(render, containerWidth)
  };
}

function round(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var factor = Math.pow(10, decimals);
  return Math.round((value + Number.EPSILON) * factor) / factor;
}

function srcSetAndSizes(photo, responsiveSizes, photoWidth, containerWidth, photosCount, spacing, padding) {
  var srcSet;
  var sizes;

  var calcSizes = function calcSizes(base) {
    var _base$match$, _base$match;

    var gaps = spacing * (photosCount - 1) + 2 * padding * photosCount;
    return "calc((".concat((_base$match$ = (_base$match = base.match(/^\s*calc\((.*)\)\s*$/)) === null || _base$match === void 0 ? void 0 : _base$match[1]) !== null && _base$match$ !== void 0 ? _base$match$ : base, " - ").concat(gaps, "px) / ").concat(round((containerWidth - gaps) / photoWidth, 5), ")");
  };

  var images = photo.srcSet;

  if (images && images.length > 0) {
    srcSet = images.concat(!images.some(function (_ref3) {
      var width = _ref3.width;
      return width === photo.width;
    }) ? [{
      src: photo.src,
      width: photo.width,
      height: photo.height
    }] : []).sort(function (first, second) {
      return first.width - second.width;
    }).map(function (image) {
      return "".concat(image.src, " ").concat(image.width, "w");
    }).join(", ");
  }

  if (responsiveSizes !== null && responsiveSizes !== void 0 && responsiveSizes.size) {
    sizes = (responsiveSizes.sizes || []).map(function (_ref4) {
      var viewport = _ref4.viewport,
          size = _ref4.size;
      return "".concat(viewport, " ").concat(calcSizes(size));
    }).concat(calcSizes(responsiveSizes.size)).join(", ");
  } else {
    sizes = "".concat(Math.ceil(photoWidth / containerWidth * 100), "vw");
  }

  return {
    srcSet: srcSet,
    sizes: sizes
  };
}

export { clsx, cssClass, cssVar, ratio, resolveCommonProps, resolveResponsiveParameter, round, srcSetAndSizes, unwrap, unwrapParameter };